module.exports = __webpack_public_path__ + "static/media/4.38162ec5.jpg";